import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';

import { createRandomMeasurement } from 'src/mocks/readerMeasurements';
import { replacePathParams } from 'src/utils/replacePathWithParams';
import { MeasurementReqParams } from '@dynamika-shared/types/measurements';

export const createMeasurementMock = async (taskId: string) => {
  const data = createRandomMeasurement();

  axiosMock
    .onPost(replacePathParams(API_URL.readerTaskMeasurements, { taskId }))
    .reply(200, data);
};

export const updateMeasurementMock = async (
  taskId: string,
  measurementId: string,
  req: MeasurementReqParams
) => {
  const data = createRandomMeasurement(measurementId);
  axiosMock
    .onPut(
      replacePathParams(API_URL.readerTaskMeasurement, {
        taskId,
        measurementId,
      })
    )
    .reply(200, { ...data, ...req });
};

export const deleteMeasurementMock = async (
  taskId: string,
  measurementId: string
) => {
  axiosMock
    .onDelete(
      replacePathParams(API_URL.readerTaskMeasurement, {
        taskId,
        measurementId,
      })
    )
    .reply(200, 'OK');
};

export const lockMeasurementMock = async (
  taskId: string,
  measurementId: string
) => {
  axiosMock
    .onPost(
      replacePathParams(API_URL.readerTaskMeasurementLock, {
        taskId,
        measurementId,
      })
    )
    .reply(200, 'OK');
};

export const unlockMeasurementMock = async (
  taskId: string,
  measurementId: string
) => {
  axiosMock
    .onPost(
      replacePathParams(API_URL.readerTaskMeasurementUnlock, {
        taskId,
        measurementId,
      })
    )
    .reply(200, 'OK');
};
export const confirmScreenshotMeasurementMock = async (
  taskId: string,
  measurementId: string
) => {
  axiosMock
    .onPost(
      replacePathParams(API_URL.readerTaskMeasurementScreenshot, {
        taskId,
        measurementId,
      })
    )
    .reply(200, 'OK');
};

export const getScreenshotMeasurementMock = async (
  taskId: string,
  measurementId: string
) => {
  axiosMock
    .onGet(
      replacePathParams(API_URL.readerTaskMeasurementGetScreenshot, {
        taskId,
        measurementId,
      })
    )
    .reply(200, 'OK');
};
